const translations = {
    body: 'You have unsaved changes. Do you want to save them before leaving?',
    confirmText: 'Save',
    declineText: "Don't save",
    title: 'Save changes?'
};

export default translations;
